/**
 * Application route constants
 */

export const ROUTES = {
  // Authentication
  LOGIN: '/login',
  LOGOUT: '/logout',
  
  // Main Dashboards
  EXECUTIVE_DASHBOARD: '/executive-dashboard',
  DEPARTMENT_MANAGER_HUB: '/department-manager-hub',
  DEPARTMENT_MANAGEMENT: '/department-management',
  STAFF_WORKFLOW_CENTER: '/staff-workflow-center',
  STAFF_WORKFLOW: '/staff-workflow-center',
  
  // Management Modules
  INVENTORY_MANAGEMENT: '/inventory-management',
  USER_MANAGEMENT: '/user-management',
  BUDGET_MANAGEMENT: '/budget-management',
  
  // Financial Modules
  FINANCIAL_ANALYTICS: '/financial-analytics-dashboard',
  FINANCIAL_REPORTS: '/financial-reports-center',
  
  // User Settings
  PROFILE_SETTINGS: '/profile-settings',
  
  // Utility
  ACCESS_DENIED: '/access-denied',
  NOT_FOUND: '*',
};

export default ROUTES;
